import React from "react";
import { Link } from "react-router-dom";
import Images from "../../Components/base/Images";
import Icon from "../base/Icon";

const Brand = ({ asideStatus, setAsideStatus }) => {
  return (
    <div className="brand">
      <div className="brand-logo">
        <h1 className="brand-title">
          <Link to="/" aria-label="Logo">
            <Images path={"logo/logo_white.png"} style={{ height: "2.3rem", marginLeft: "0.625rem" }} />
          </Link>
        </h1>
      </div>
      <button
        type="button"
        className="btn brand-aside-toggle"
        aria-label="Toggle Aside"
        onClick={() => setAsideStatus(!asideStatus)}
      >
        <Icon iconName={"ChevronFirst"} className="brand-aside-toggle-close" />
        <Icon iconName={"ChevronLast"} className="brand-aside-toggle-open" />
      </button>
    </div>
  );
};

export default Brand;
